import { Component } from "@angular/core";

@Component({
  selector: "ch-mylly",
  templateUrl: "./mylly.component.html",
})
export class MyllyHasMovedComponent {
  constructor() {}
}
